import { createApp } from 'vue'
import { createPinia } from 'pinia'
import i18n from '@/i18n'
import FloatingVue from 'floating-vue'
import { vOneTooltip } from './thirdparty/one-tooltip/oneTooltipDirective'
import OneTooltip from './thirdparty/one-tooltip/one-tooltip.vue'

import LoginTabs from '@/components/login/LoginTabs.vue'
import LangSelector from './components/login/LangSelector.vue'
import LicenseActivator from '@/components/login/LicenseActivator.vue'
import Notifications from './components/dashboard/Notifications.vue'
import OverallStatusChart from '@/components/dashboard/OverallStatusChart.vue'
import ProgressChart from '@/components/dashboard/ProgressChart.vue'
import ApproachingDueDate from '@/components/dashboard/ApproachingDueDate.vue'
import DueDateMethods from '@/components/dashboard/DueDateMethods.vue'
import ReviewDateNotification from '@/components/dashboard/ReviewDateNotification.vue'
import AuditBtn from '@/components/audit/AuditBtn.vue'
import EditMethodsBtn from '@/components/methods/EditMethodsBtn.vue'
import EditMethodsToolbar from '@/components/methods/EditMethodsToolbar.vue'
import MethodTable from '@/components/methods/MethodTable.vue'
import UsersPage from '@/components/user/UsersPage.vue'
import InstanceTable from '@/components/instance/InstanceTable.vue'
import ModuleTable from '@/components/module/ModuleTable.vue'
import AssetTable from '@/components/asset/AssetTable.vue'
import DataAssetTable from '@/components/data_asset/DataAssetTable.vue'
import SecurityMethod from '@/components/business_processes/SecurityMethod.vue'
import MassEditMethodsBtn from '@/components/methods/MassEditMethodsBtn.vue'
import InstanceAutocomplete from '@/components/widgets/InstanceAutocomplete.vue'
import JiraToolbar from '@/components/jira/JiraToolbar.vue'
import JiraExportBtn from '@/components/jira/JiraExportBtn.vue'
import MethodExportBtn from '@/components/methods/MethodExportBtn.vue'
import ImportMethodsModal from '@/components/methods/ImportMethodsModal.vue'
import ConfigEdit from '@/components/jira/ConfigEdit.vue'
import Slider from '@/components/widgets/Slider.vue'
import Modal from '@/components/widgets/ModalComponent.vue'
import Toaster from '@/components/widgets/Toaster.vue'
import BusinessProcessChart from '@/components/business_processes/BusinessProcessChart.vue'
import BpCustom from './components/business_processes/BpCustom.vue'
import CustomFieldEditor from '@/components/settings/CustomFieldEditor.vue'
import LegacyCustomViewer from '@/components/custom_field/LegacyCustomViewer.vue'
import LegacyCustomEditor from '@/components/custom_field/LegacyCustomEditor.vue'
import IconButton from '@/components/shared/IconButton.vue'
import HeaderComponent from '@/components/shared/HeaderComponent.vue'
import SideNav from '@/components/shared/SideNav.vue'
import RightSideContent from '@/components/widgets/RightSideContent.vue'
import BpConnections from './components/business_processes/BpConnections.vue'
import ExportBtn from './components/widgets/ExportBtn.vue'
import DataAssetPage from './components/data_asset/DataAssetPage.vue'
import ResponsibleSelect from './components/widgets/ResponsibleSelect.vue'
import SettingsPage from './components/settings/SettingsPage.vue'
import AssetPage from './components/asset/AssetPage.vue'
import InstancePage from './components/instance/InstancePage.vue'
import BpPage from './components/business_processes/BpPage.vue'
import ModulePage from './components/module/ModulePage.vue'
import MethodResponsibleCost from './components/dashboard/MethodResponsibleCost.vue'
import DocumentPage from './components/document/DocumentPage.vue'
import RiskManagementPage from './components/risk_management/RiskManagementPage.vue'
import URLReference from './components/comment_references/URLReference.vue'
import DocumentReference from './components/comment_references/DocumentReference.vue'
import RisksPane from './components/risk_management/RisksPane.vue'
import JournalPage from './components/journal/JournalPage.vue'
import RiskOverviewInstances from './components/risk_management/overview/RiskOverviewInstances.vue'

export const createVue = () =>
	createApp({})
		.use(createPinia())
		.use(i18n)
		.use(FloatingVue)
		.directive('one-tooltip', vOneTooltip)

		// Component registration (only required for global availability)
		.component('loginTabs', LoginTabs)
		.component('langSelector', LangSelector)
		.component('licenseActivator', LicenseActivator)
		.component('dashboardOverallStatusChart', OverallStatusChart)
		.component('dashboardProgressChart', ProgressChart)
		.component('dashboardApproachingDueDate', ApproachingDueDate)
		.component('dashboardDueDateMethods', DueDateMethods)
		.component('dashboardNotifications', Notifications)
		.component('editMethodsBtn', EditMethodsBtn)
		.component('editMethodsToolbar', EditMethodsToolbar)
		.component('massEditMethodsBtn', MassEditMethodsBtn)
		.component('methodTable', MethodTable)
		.component('securityMethod', SecurityMethod)
		.component('jiraToolbar', JiraToolbar)
		.component('jiraExportBtn', JiraExportBtn)
		.component('methodExportBtn', MethodExportBtn)
		.component('importMethodsModal', ImportMethodsModal)
		.component('instanceAutocomplete', InstanceAutocomplete)
		.component('slider', Slider)
		.component('modal', Modal)
		.component('toaster', Toaster)
		.component('auditBtn', AuditBtn)
		.component('configEdit', ConfigEdit)
		.component('usersPage', UsersPage)
		.component('instanceTable', InstanceTable)
		.component('moduleTable', ModuleTable)
		.component('assetTable', AssetTable)
		.component('dataAssetTable', DataAssetTable)
		.component('bpChart', BusinessProcessChart)
		.component('bpCustom', BpCustom)
		.component('reviewDateNotification', ReviewDateNotification)
		.component('customFieldEditor', CustomFieldEditor)
		.component('legacyCustomViewer', LegacyCustomViewer)
		.component('legacyCustomEditor', LegacyCustomEditor)
		.component('iconButton', IconButton)
		.component('headerComponent', HeaderComponent)
		.component('sideNav', SideNav)
		.component('rightSideContent', RightSideContent)
		.component('bpConnections', BpConnections)
		.component('exportBtn', ExportBtn)
		.component('dataAssetPage', DataAssetPage)
		.component('responsibleSelect', ResponsibleSelect)
		.component('assetPage', AssetPage)
		.component('instancePage', InstancePage)
		.component('bpPage', BpPage)
		.component('modulePage', ModulePage)
		.component('settingsPage', SettingsPage)
		.component('methodResponsibleCost', MethodResponsibleCost)
		.component('riskManagementPage', RiskManagementPage)
		.component('oneTooltip', OneTooltip)
		.component('documentsPage', DocumentPage)
		.component('urlReference', URLReference)
		.component('documentReference', DocumentReference)
		.component('risksPane', RisksPane)
		.component('journalPage', JournalPage)
		.component('riskOverviewInstances', RiskOverviewInstances)
